/*
 * FORM LOADING IMPLEMENTATION NOTES:
 * ===================================
 * 
 * This application now supports loading form data via URL parameters instead of hidden inputs.
 * 
 * HOW IT WORKS:
 * 1. Checks for 'formid' URL parameter (e.g., ?formid=123-456-789)
 * 2. If formid exists, calls GET /api/Form/GetById?id={formid}
 * 3. Transforms response.data from new format to legacy format using transformFormModelToLegacyFormat()
 * 4. Binds transformed data to existing form using personalLoan.goodsType.bindForm()
 * 5. If no saved data, starts fresh application
 * 
 * TESTING:
 * - Run testTransformation() in browser console to validate transformation function
 * - Sample test data is available in window.testSampleData
 * 
 * ERROR HANDLING:
 * - API failures gracefully fall back to fresh application start
 * - Transformation errors are logged and handled safely
 * - All errors preserve user experience by starting fresh form
 * 
 * COMPATIBILITY:
 * - Preserves all existing analytics tracking (ApplicationRestart events)
 * - No breaking changes to existing functionality
 */

// Expose a function to the reCaptcha callback function
window.reCaptchaFinancialPositionID = null
window.reCaptchaApplicationOptionsID = null
window.onReCaptchaLoadCallback = function() {
    // We need to handle 2 different recaptcha instances on the personal loan application
    console.log('Explicitly render reCaptcha')

    // reCaptcha for financial position
    const reCaptchaFinancialPositionElement = document.querySelector('.js-recaptcha-financial-position')
    window.reCaptchaFinancialPositionID = grecaptcha.render(reCaptchaFinancialPositionElement, {
        'sitekey': reCaptchaFinancialPositionElement.getAttribute('data-sitekey')
    })

    // reCaptcha for application options
    const reCaptchaApplicationOptionsElement = document.querySelector('.js-recaptcha-application-options')
    window.reCaptchaApplicationOptionsID = grecaptcha.render(reCaptchaApplicationOptionsElement, {
        'sitekey': reCaptchaApplicationOptionsElement.getAttribute('data-sitekey')
    })
}

if (window.personalLoan === undefined) window.personalLoan = {}

window.personalLoan.app = (function () {
    var requestData = {
        Personal: true,
        GoodsType: '',
        CashPriceOfAsset: 0,
        TermsMonth: 0,
        PaymentFrequency: 'W',
        CashDeposit: 0,
        Make: '',
        Model: '',
        Year: '',
        ItemTypeVal: '',
        LoanTerm: '',
        ApplicationOptions: ''
    }

    function _startLoanApplication() {
        personalLoan.header.hideApplicationType()
        personalLoan.header.showMenu()
        personalLoan.header.setActiveMenu('your-details')
        personalLoan.router.go('your-details')

        _pushDataLayerPageEvent('Your details')
    }

    function _yourDetailsGoNext() {
        personalLoan.header.setActiveMenu('about-you')
        personalLoan.router.go('about-you')

        _pushDataLayerPageEvent('About you')
    }

    function _updateNextButtonState(isDisabled) {
        const nextButton = $('#aboutYouGoNext')
        nextButton.prop('disabled', isDisabled)
        nextButton.removeClass(isDisabled ? 'btn-primary' : 'btn-secondary')
                  .addClass(isDisabled ? 'btn-secondary' : 'btn-primary')
        if (!isDisabled) {
            nextButton.removeAttr('style')
        }
    }

    function _aboutYouGoNext() {
        const isNZResidentNo = $('#nzResident').val() === 'No' || $('#nzResident').val() === ''
        const isCoborrowerNZResidentNo = $('#coborrowernzResident').val() === 'No' || $('#coborrowernzResident').val() === ''
        const isJoint = $('#applicationSubType').val().toLowerCase() === 'joint'

        if (isAAMoneyDealer && (isNZResidentNo || (isJoint && isCoborrowerNZResidentNo))) {
             $('.js-citizen-status').fadeIn()
            _updateNextButtonState(true)
             return
        } else {
            $('.js-citizen-status').fadeOut()
            _updateNextButtonState(false)
        }

        personalLoan.header.setActiveMenu('employment-details')
        personalLoan.router.go('employment-details')

        _pushDataLayerPageEvent('Income')
    }

    function _employmentDetailsGoNext() {
        personalLoan.header.setActiveMenu('financial-position')
        personalLoan.router.go('financial-position')

        _pushDataLayerPageEvent('Financial position') 
    }

    function _goBack (currentPlace) {
        if (currentPlace === 'about-you') {
            personalLoan.header.setActiveMenu('your-details')
            personalLoan.router.go('your-details')
        } else if (currentPlace === 'employment-details') {
            personalLoan.header.setActiveMenu('about-you')
            personalLoan.router.go('about-you')
        } else if (currentPlace === 'financial-position') {
            personalLoan.header.setActiveMenu('employment-details')
            personalLoan.router.go('employment-details')
        } else if (currentPlace === 'application-options') {
            personalLoan.header.setActiveMenu('financial-position')
            personalLoan.router.go('financial-position')
        }
    }

    function _applicationOptionsNext() {
        // Pass form data for application options section
        personalLoan.applicationOptions.populateApplicationOptionsInfo(window.form)

        personalLoan.header.setActiveMenu('application-options')
        personalLoan.router.go('application-options')

        _pushDataLayerPageEvent('Documents')
    }

    function _thanksYou(res) {
        personalLoan.header.setActiveMenu('thank-you')
        personalLoan.router.go('thank-you')

        _pushDataLayerPageEvent('Completed application')

        let name = `<strong>${$('#firstName').val()} ${$('#lastName').val()}</strong>`
        let coBorrowerName = `<strong>${$('#coborrowerfirstName').val()} ${$('#coborrowerlastName').val()}</strong>`

        if ($('#applicationSubType').val() === 'Joint') {
            name += ' and ' + coBorrowerName
        }
        $('.applicant-names').each(function() { $(this).html(name) })
        $('.loan-details').addClass('hidden-important')
        $('.btn-save-application').addClass('hidden')
        $('#navbarNav').removeClass().addClass('hidden-important')

        displayApplicationOptionsStatus(res)
        fadeInApplicationOptionsItem() 
    }

    function displayApplicationOptionsStatus(res) {
        // Handle submit form response, such as application options
        if (!!res) {
            // Form submitted with application options specified
            if (!!res.data) {
                const responseData = Object.keys(res.data)

                if (!window.form) return
                
                const submittedIsJoint = window.form.IsJoint
                const submittedCheckedAplyID = window.form.IsCheckedAplyID
                const submittedCheckedThisIsBud = window.form.IsCheckedThisIsBud
                const submittedCoBorrowerIsCheckedAplyID = window.form.Personal.CoBorrowerIsCheckedAplyID
                const submittedCoBorrowerIsCheckedThisIsBud = window.form.Personal.CoBorrowerIsCheckedThisIsBud

                // Send event to GA
                if (submittedCheckedAplyID) {
                    window.dataLayer.push({'event': 'individual_APLYiD_submit'})
                }

                if (submittedCheckedThisIsBud) {
                    window.dataLayer.push({'event': 'individual_Bud_submit'})
                }

                if (submittedCoBorrowerIsCheckedAplyID) {
                    window.dataLayer.push({'event': 'individual_APLYiD_coborrower_submit'})
                }

                if (submittedCoBorrowerIsCheckedThisIsBud) {
                    window.dataLayer.push({'event': 'individual_bud_coborrower_submit'})
                }

                // Update thankyou page info based on Bud optin
                function updateThankYouBudInfo() {
                    const jsThankyouBud = document.querySelector('#js-thank-you-bud')
                    jsThankyouBud.innerHTML = 'We will use Bud to verify your financial information'
                }
              
                // Filter responseData based on form data
                function filterResponseData(isJoint, primaryAplyId, primaryBud, secondaryAlyid, secondaryBud, keys) {
                    let filterKeys = []
                    if (isJoint) {
                        keys.forEach(function(item) {                          
                            if (primaryAplyId && 
                                item.toLowerCase().trim().includes('primary') && 
                                item.toLowerCase().trim().includes('aplyid') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)
                            } else if (primaryBud && 
                                item.toLowerCase().trim().includes('primary') && 
                                item.toLowerCase().trim().includes('bud') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)
                                
                                updateThankYouBudInfo()
                            } else if (secondaryAlyid && 
                                item.toLowerCase().trim().includes('secondary') && 
                                item.toLowerCase().trim().includes('aplyid') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)
                            } else if (secondaryBud && 
                                item.toLowerCase().trim().includes('secondary') && 
                                item.toLowerCase().trim().includes('bud') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)

                                updateThankYouBudInfo()
                            }
                        })
                    } else {
                        keys.forEach(function(item) {                            
                            if (primaryAplyId && 
                                item.toLowerCase().trim().includes('primary') && 
                                item.toLowerCase().trim().includes('aplyid') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)
                            } else if (primaryBud && 
                                item.toLowerCase().trim().includes('primary') && 
                                item.toLowerCase().trim().includes('bud') && 
                                item.toLowerCase().trim().includes('status')) {
                                filterKeys.push(item)

                                updateThankYouBudInfo()
                            }
                        })
                    }

                    return filterKeys
                }

                const thankYouHeading = document.querySelector('#thank-you-heading')

                for (let i of filterResponseData(submittedIsJoint, submittedCheckedAplyID, submittedCheckedThisIsBud, submittedCoBorrowerIsCheckedAplyID, submittedCoBorrowerIsCheckedThisIsBud, responseData).reverse()) {
                    // Get response data item detail
                    let submittedPrimaryFirstName = window.form['FirstName']

                    let submittedSecondaryFirstName = window.form.Personal['CoBorrowerFirstName']

                    let submittedApplicationOption = 'Bud'
                    if (i.toLowerCase().trim().includes('aplyid')) {
                        submittedApplicationOption = 'APLYiD'
                    }

                    let submittedPrimaryPhoneNumber = window.form['Phone']
                    let submittedPrimaryEmail = window.form['Email']

                    let submittedSecondaryPhoneNumber = window.form.Personal['CoBorrowerPhoneNumber']
                    let submittedSecondaryEmail = window.form.Personal['CoBorrowerEmail']

                    let htmlAfterHeading = `
                        ${
                            i.toLowerCase().trim().includes('primary') ? 
                            `<div class="application-options-res hidden-res">
                                ${
                                    !res.data?.primaryApplicantAplyIdStatus?.isSuccess ? 
                                    `<div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fail-icon">
                                            <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
                                        </svg>
                                    </div>

                                    <div class="res-details fail">
                                        <h3>${submittedPrimaryFirstName}, we seem to have had a bit of a hiccup connecting to ${submittedApplicationOption}.</h3>

                                        ${
                                            submittedApplicationOption === 'APLYiD' ? 
                                            `<p>
                                                Don't worry, one of our team will send you an SMS to verify your ID shortly.
                                            </p>`
                                            : 
                                            `<p>
                                                Don't worry, one of our team will send you a link to Bud shortly.
                                            </p>`
                                        }
                                    </div>`
                                    :
                                    `
                                    <div class="application-options-indicator-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="succeed-icon">
                                            <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                                        </svg>
                                    </div>
                                    
                                    <div class="res-details succeed">
                                        
                                        ${
                                            submittedApplicationOption === 'APLYiD' ? 
                                            `
                                            <h3>${submittedPrimaryFirstName}, ready to verify your ID with ${submittedApplicationOption}?</h3>
                                            <p>
                                                You will receive an SMS on ${submittedPrimaryPhoneNumber} with how to proceed shortly.
                                            </p>`
                                            : 
                                            `
                                            <h3>${submittedPrimaryFirstName}, ready to verify your income with ${submittedApplicationOption}?</h3>
                                            <p>
                                                You can start the income verification process <a href="${res.data[i].URL}" target="_blank" rel="noreferrer noopener" id="ga4-continue-income-verification-primaryborrower" onclick="window.dataLayer.push({ event: 'individual_income_verification_click' })">here</a> (this will open in a new window)
                                            </p>

                                            <p>
                                                If you're not ready, we've sent you an email to ${submittedPrimaryEmail} containing your unique link, which is valid for 24 hours.
                                            </p>`
                                        }
                                    </div>`   
                                }  
                            </div>` 
                            : 
                            `<div class="application-options-res hidden-res">
                                ${
                                    !res.data?.secondaryApplicantAplyIdStatus?.isSuccess ? 
                                    `<div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fail-icon">
                                            <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
                                        </svg>
                                    </div>

                                    <div class="res-details fail">
                                        <h3>${submittedSecondaryFirstName}, we seem to have had a bit of a hiccup connecting to ${submittedApplicationOption}.</h3>
                                        ${
                                            submittedApplicationOption === 'APLYiD' ? 
                                            `<p>
                                                Don't worry, one of our team will send you an SMS to verify your ID shortly.
                                            </p>`
                                            : 
                                            `<p>
                                                Don't worry, one of our team will send you a link to Bud shortly.
                                            </p>`
                                        }
                                    </div>` 
                                    :
                                    `
                                    <div class="application-options-indicator-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="succeed-icon">
                                            <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                                        </svg>
                                    </div>
                                    
                                    <div class="res-details succeed">
                                        
                                        ${
                                            submittedApplicationOption === 'APLYiD' ? 
                                            `
                                            <h3>${submittedSecondaryFirstName}, ready to verify your ID with ${submittedApplicationOption}?</h3>
                                            <p>
                                                You will receive an SMS on ${submittedSecondaryPhoneNumber} with how to proceed shortly.
                                            </p>`
                                            : 
                                            `
                                            <h3>${submittedSecondaryFirstName}, ready to verify your income with ${submittedApplicationOption}?</h3>
                                            <p>
                                                You can start the income verification process <a href="${res.data[i].URL}" target="_blank" rel="noreferrer noopener" id="ga4-continue-income-verification-coborrower" onclick="window.dataLayer.push({ event: 'individual_income_verification_coborrower_click' })">here</a> (this will open in a new window)
                                            </p>

                                            <p>
                                                If you're not ready, we've sent you an email to ${submittedSecondaryEmail} containing your unique link, which is valid for 24 hours.
                                            </p>`
                                        }
                                        
                                    </div>`   
                                }  
                            </div>` 
                        }
                    `
                    thankYouHeading.insertAdjacentHTML("afterend", htmlAfterHeading)
                }
            }
        }
    }

    function fadeInApplicationOptionsItem() {
        const resItems = document.querySelectorAll('.hidden-res')

        resItems.forEach(function(item, index) {
            let timeItem = index + 1
            setTimeout(function() {
                item.classList.remove('hidden-res')
            }, timeItem * 150)
        })
    }

    function displayMessageModal() {
        const maskWrapper = document.querySelector('.mask-wrapper')

        let originalHTML = ``

        if (!!maskWrapper) {
            originalHTML = maskWrapper.innerHTML
            maskWrapper.classList.remove('hidden')
            maskWrapper.innerHTML = `
                <div class="response-message">
                    <div class="message-row">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
                        </svg>
                        <div>
                            <h2>Upload Failed</h2>
                            <p>There was an error uploading your file. Please try again.</p>
                        </div>
                    </div>
                    <button class="response-message-button">Back to file upload</p>
                </div>
            `
        }

        const responseMessageButton = document.querySelector('.response-message-button')
        if (!!responseMessageButton) {
            responseMessageButton.addEventListener('click', function() {
                maskWrapper.classList.add('hidden')
                maskWrapper.innerHTML = originalHTML
            })
        }
    }

    // Based on the page title, push the event, but for the AA money don't include `personal/` in the URL
    function _pushDataLayerPageEvent(virtualPageTitle) {
        const isAAMoneyDealer = document.getElementById('isAAMoneyDealer').value === 'true'
        const pageTitleToPathMatcher = {
            'Your details': 'your-details',
            'About you': 'about-you',
            'Income': 'income',
            'Financial position': 'financial-position',
            'Documents': 'doc-upload',
            'Completed application': 'end-application'
        }
        
        // Check if virtualPageTitle is in the object, otherwise don't do anything
        if (pageTitleToPathMatcher[virtualPageTitle]) {
            let virtualPageURL = window.location.origin + '/personal/' + pageTitleToPathMatcher[virtualPageTitle]
            if (isAAMoneyDealer) {
                virtualPageURL = window.location.origin + window.location.pathname + '/' + pageTitleToPathMatcher[virtualPageTitle]
            }

            console.log('virtualPageURL', virtualPageURL)

            window.dataLayer.push({ 
                event: 'Pageview', 
                virtualPageURL: virtualPageURL,
                virtualPageTitle: virtualPageTitle
            })

            window.dataLayer.push({ 
                event: 'page_view', 
                page_path: 'personal/' + pageTitleToPathMatcher[virtualPageTitle] + window.location.search,
                page_location: virtualPageURL,
                page_title: 'Personal - ' + virtualPageTitle
            })
        }
    }

    function _loanApplicationFinish(isSubmittingFromFinancialPositionStep = false) {
        // Add notes to external notes
        applyNoteOnSubmit()

        // Need to pass the recaptcha ID to the loan submit function based on the step
        // If the user is on the Financial position step, then we need to pass reCaptchaFinancialPositionID
        // If the user is on the Application options step, then we need to pass reCaptchaApplicationOptionsID
        let reCaptchaID = null
        let anyRecaptchaError = false
        if (isSubmittingFromFinancialPositionStep) {
            reCaptchaID = window.reCaptchaFinancialPositionID
            let recaptchaResponse = grecaptcha.getResponse(reCaptchaID)

            if (recaptchaResponse === '') {
                anyRecaptchaError = true
                $('.js-recaptcha-financial-position').find('iframe').attr('style', 'border: 1px solid red')
                $('.js-recaptcha-financial-position').parent().find('.error').attr('style', 'display: block')
            }
        } else {
            reCaptchaID = window.reCaptchaApplicationOptionsID
            let recaptchaResponse = grecaptcha.getResponse(reCaptchaID)

            if (recaptchaResponse === '') {
                anyRecaptchaError = true
                $('.js-recaptcha-application-options').find('div > iframe').attr('style', 'border: 1px solid red')
                $('.js-recaptcha-application-options').parent().find('.error').attr('style', 'display: block')
            }
        }

        if (anyRecaptchaError) {
            return
        }

        scrollToTop()
        personalLoan.goodsType.submitForm(reCaptchaID)
    }

    function applyNoteOnSubmit() {
        // Apply addtional note extra information here. Add a note of application options for UDC live
        if ($personalLoanForm.my('data').IsCheckedAplyID) {
            $personalLoanForm.my('data').Asset.AdditionalNotes += '\n The main applicant has applied for ApplyID. '
        }

        if ($personalLoanForm.my('data').IsCheckedThisIsBud) {
            $personalLoanForm.my('data').Asset.AdditionalNotes += '\n The main applicant has applied for ThissisBud. '
        }

        if ($personalLoanForm.my('data').Personal.CoBorrowerIsCheckedThisIsBud) {
            $personalLoanForm.my('data').Asset.AdditionalNotes += '\n The co-borrower has applied for ThissisBud. '
        }
        
        if ($personalLoanForm.my('data').Personal.CoBorrowerIsCheckedAplyID) {
            $personalLoanForm.my('data').Asset.AdditionalNotes += '\n The co-borrower has applied for ApplyID. '
        }
    }

    return {
        startLoanApplication: _startLoanApplication,
        yourDetailsGoNext: _yourDetailsGoNext,
        aboutYouGoNext: _aboutYouGoNext,
        employmentDetailsGoNext: _employmentDetailsGoNext,
        applicationOptionsNext: _applicationOptionsNext,
        thanksYou: _thanksYou,
        submitLoan: _loanApplicationFinish,
        goBack: _goBack,
        requestData: requestData
    }
})();

jQuery(function () {
    /* Generic global event listeners */
    window.personalLoan.globalListeners.init()
    /* Start Application event listeners */
    $navbarNav = jQuery('#navbarNav')
    $termsAcceptance = jQuery('.js-terms-acceptance')
    $startApplicationButton = jQuery('.js-start-application')
    $yourDetailsGoNext = jQuery('.js-your-details-go-next')
    $requestCallbackSubmit = jQuery('#requestCallBackSubmit')
    $aboutYouGoNext = jQuery('.js-about-you-go-next')
    $employmentDetailsGoNext = jQuery('.js-employment-details-go-next')
    $applicationOptionsNext = jQuery('.js-application-options-go-next')
    $financialPositionFinish = jQuery('.js-financial-position-finish')
    $financialPositionFinishDealer = jQuery('.js-financial-position-finish-dealer')
    $applicationOptionsFinish = jQuery('.js-application-options-finish')
    $btnAddPurchaseItem = jQuery('.js-add-purchase-item')
    $personalLoanForm = jQuery(".personal-loan").eq(0)
    $aboutYouGoBack = jQuery('.js-about-you-go-back')
    $employmentDetailsGoBack = jQuery('.js-employment-details-go-back')
    $financialPositionGoBack = jQuery('.js-financial-position-go-back')
    $applicationOptionsGoBack = jQuery('.js-application-options-go-back')
    $dobPopupOverlay = $('.js-dob-popup')
    $dobError = $('#dobError')
    $dobInput = $('#dobVerification')


    const aaLoanType = $('#loanTypeAAMoney').val()
    if (aaLoanType !== 'aa-personal') {
        $personalLoanForm.my("data").AAPersonal = null
    }

    // Check if formid parameter exists in URL
    // Check for formId/formid in URL with case insensitive match
    const formId = window.getParameterByName('formid') || window.getParameterByName('formId')

    if (formId) {
        // Pre-check if DOB is needed for this saved application
        $.ajax({
            url: `/api/Form/IsDobNeeded?id=${formId}`,
            method: 'GET',
            success: function(res) {
                try {
                    const needDob = (res && (res.data === true || res === true))
                    if (needDob) {
                        showDobPopup(formId)
                        $('.dob-popup').fadeIn()
                    } else {
                        loadFormFromApi(formId)
                    }
                } catch (e) {
                    // On any parsing error, fall back to normal flow
                    loadFormFromApi(formId)
                }
            },
            error: function(error) {
                if(error.status === 410) {
                    startNewApplication()
                    triggerInitialPageEvent()
                    return
                }
                // If the pre-check fails, fall back to normal flow (no DOB gate)
                loadFormFromApi(formId)
            }
        })
    } else {
        // If no saved form data, start fresh - trigger initial page event
        triggerInitialPageEvent()
    }

    function loadFormFromApi(formId, dob) {
        // Make API call to get form data (optionally with dob)
        const dobParam = dob ? `&dob=${encodeURIComponent(dob)}` : ''
        $.ajax({
            url: `/api/Form/GetById?id=${formId}${dobParam}`,
            method: 'GET',
            success: function(response) {
                try {
                    if (response && response.data) {
                        $dobPopupOverlay.addClass('hidden')
                        // In the case of the DevToolkit the response doesn't return the Id, so we need to add it manually
                        if (response.data.formId === null) {
                            $personalLoanForm.my('data').Id = formId
                            response.data.formId = formId
                        }
                        // Transform new format to legacy format
                        const legacyFormData = transformFormModelToLegacyFormat(response.data)
                        
                        if (legacyFormData) {
                            // Bind the transformed form data
                            const interval = setInterval(() => {
                                if (window.areDealerSettingsLoaded) {
                                    personalLoan.goodsType.bindForm(legacyFormData)
                                    triggerInitialPageEvent()
                                    clearInterval(interval)
                                }
                            }, 100)

                            // We want to trigger the event only once per session, so we don't consider a simple page refresh as another application restart
                            if (window.sessionStorage.getItem('applicationRestart') === null) {
                                window.dataLayer.push({
                                    event: 'ApplicationRestart'
                                })
                                window.sessionStorage.setItem('applicationRestart', 'true')
                            }
                        } else {
                            console.error('Failed to transform form data to legacy format')
                            triggerInitialPageEvent()
                        }
                    } else {
                        console.error('Invalid response format from API')
                        triggerInitialPageEvent()
                    }
                } catch (error) {
                    console.error('Error processing form data:', error)
                    triggerInitialPageEvent()
                }
            },
            error: function(xhr, status, error) {
                console.log('error', error)
                if(xhr?.responseJSON?.responseMessage) {
                    setError(xhr?.responseJSON?.responseMessage)
                }
                console.error('Failed to load form data from API:', error)
                // Fall back to fresh start if API call fails
                triggerInitialPageEvent()
            }
        })
    }

    function formatDateToYyyyMmDd(date) {
        const [day, month, year] = date?.split('/') || []
        if (!day || !month || !year) {
            return ''
        }
        return `${year}-${month}-${day}`;
    }

    function setError(message) {
        $dobError.text(message || 'Please enter a valid date of birth')
        $dobError.attr('style', 'display:block')
        // align the error message to the left
        $dobError.css('text-align', 'left')
        $dobInput.attr('style', 'border-color:red').addClass('js-invalid')
    }

    function startNewApplication() {
        const url = new URL(window.location.href)
        url.searchParams.delete('formid')
        url.searchParams.delete('formId')
        window.history.replaceState({}, '', url.toString())
    }

    function showDobPopup(formId) {
        const $submitBtn = $('.js-submit-dob')
        const $startNewBtn = $('.js-start-new-application')

        if ($dobPopupOverlay.length === 0) {
            // Fallback: if popup missing, proceed without DOB (legacy behavior)
            loadFormFromApi(formId)
            return
        }

        function open() {
            $dobPopupOverlay.removeClass('hidden')
            $dobPopupOverlay.addClass('display-block')
            window.setTimeout(function () { $personalLoanForm.removeAttr('style')}, 100)
        }

        function close() {
            $('body')[0].classList.remove('overflow-hidden')
            $dobPopupOverlay.addClass('hidden')
            $('.dob-popup').fadeOut()
        }

        function clearError() {
            $dobError.text('')
            $dobInput.attr('style', '').removeClass('js-invalid')
        }

        $submitBtn.off('click').on('click', function () {
            clearError()
            const value = $dobInput.val()
            if (!value) {
                setError('Date of birth is required')
                return
            }

            const dobParam = formatDateToYyyyMmDd(value)
            loadFormFromApi(formId, dobParam)
        })

        $startNewBtn.off('click').on('click', function () {
            // Remove formid params and start a new application
            close()
            triggerInitialPageEvent()
            startNewApplication()
        })

        open()
    }

    function triggerInitialPageEvent() {
        // If the application was not saved, the current system behaves in a way that it always starts on the main page, so here is
        // the best place to trigger the GA4 pageview event
        window.dataLayer.push({ 
            event: 'page_view', 
            page_path: 'personal' + window.location.search,
            page_location: window.location.origin + '/personal',
            page_title: 'Personal - Start Application'
        })

        // Form is loaded remove style="display: none;"
        window.setTimeout(function () { $personalLoanForm.removeAttr('style')}, 100)
    }

    // toggle dropdown
    $('#dropdownMenuButton').on('click', function () {
        $(this).siblings('.dropdown-menu').toggleClass('show')
    })

    $termsAcceptance.on('click', function () {
        if ($termsAcceptance.is(':checked')) {
            $startApplicationButton
                .prop('disabled', false)
        } else {
            $startApplicationButton
                .removeClass('btn-primary')
                .addClass('btn-secondary')
                .prop('disabled', true)
        }
    })

    $startApplicationButton.on('click', function () {
        // Need to remove initial page class we used to handle different UI state for the initial page
        jQuery('.js-initial-page').removeClass('js-initial-page') 
        personalLoan.app.startLoanApplication()
    })

    $yourDetailsGoNext.on('click', function () {
        if (personalLoan.goodsType.validateYourDetails()) {
            $('.btn-save-application').removeClass('hidden')
            
            personalLoan.goodsType.saveForm(false, 'yourDetails')
            personalLoan.app.yourDetailsGoNext()

            adjustGooglePlaceAutocompleteResultsWidth()
        }
    })

    $requestCallbackSubmit.on('click', function () {
        if (personalLoan.goodsType.validateRequestCallback()) {
            personalLoan.goodsType.sendRequestCallback()
        }
    })

    // Personal application back button event listeners
    $aboutYouGoBack.on('click', () => personalLoan.app.goBack('about-you'))
    $employmentDetailsGoBack.on('click', () => personalLoan.app.goBack('employment-details'))
    $financialPositionGoBack.on('click', () => personalLoan.app.goBack('financial-position'))
    $applicationOptionsGoBack.on('click', () => personalLoan.app.goBack('application-options'))

    $aboutYouGoNext.on('click', function () {
        // TODO: find out why copyAddress is here, what does it do and probably change the name of the function to reflect better what it does as
        // it doesn't seem to be just copying the address

        const isNZResidentNo = $('#nzResident').val() === 'No' || $('#nzResident').val() === ''
        const isCoborrowerNZResidentNo = $('#coborrowernzResident').val() === 'No' || $('#coborrowernzResident').val() === ''
        const isJoint = $('#applicationSubType').val().toLowerCase() === 'joint'

        if (isAAMoneyDealer && (isNZResidentNo || (isJoint && isCoborrowerNZResidentNo))) {
            $('.js-citizen-status').fadeIn()
            return
        }

        personalLoan.goodsType.copyAddress()

        if (personalLoan.goodsType.validateAboutYou()) {
            personalLoan.goodsType.saveForm(false, 'aboutYou')
            personalLoan.app.aboutYouGoNext()
        } else {
            onClickScrollToError($('div.content-wrapper[style*="display: block"] input[style*="border-color:red"]'), 0, 600)
        }
    })

    $employmentDetailsGoNext.on('click', function () {
        if (personalLoan.goodsType.validateEmployeementDetails()) {
            $personalLoanForm.my("data").OtherIncomes = personalLoan.goodsType.getOtherIncomes()
            //$personalLoanForm.my("data", model);
            personalLoan.goodsType.saveForm(false, 'income')
            personalLoan.app.employmentDetailsGoNext()
        } else {
            onClickScrollToError($('div.content-wrapper[style*="display: block"] input[style*="border-color:red"]'), 0, 600)
        }
    })


    // Callback for personal application financial position next section (application options) and Dealer application financial position next section (Finish)
    const validateFinancialPositionAndNext = function (nextSection) {
        const isFormValid = personalLoan.goodsType.validateFinancialPosition()
        const $fields = $('.js-amount-validate')
        let list = []
 
        $fields.each(function (i) {
            const res = personalLoan.goodsType.validateAmount($(this))
            if (res !== undefined && !res)
                list.push(res);
        })

        if (list.length === 0 && isFormValid) {
            $personalLoanForm.my("data").OtherAssets = personalLoan.goodsType.getAssets()
            let sum = 0
            $personalLoanForm.my("data").OtherAssets.forEach(function (item) {
                sum += parseInt(item.Amount)
            })

            $personalLoanForm.my("data").Asset.OtherValue = parseFloat(sum)
            $personalLoanForm.my("data").Asset.OtherMonthlyPayment = personalLoan.goodsType.getOtherMonthlyPaymentSum()
            $personalLoanForm.my("data").Asset.OtherAmount = personalLoan.goodsType.getOtherAssetAmountSum()

            if (nextSection === 'applicationOptions') {
                personalLoan.goodsType.saveForm(false, 'financialPosition')
                personalLoan.app.applicationOptionsNext()
            } else {
                personalLoan.app.submitLoan()
            }
            
        } else {
            if ($('div.content-wrapper[style*="display: block"] input[style*="border-color:red"]').length !== 0) {
                onClickScrollToError($('div.content-wrapper[style*="display: block"] input[style*="border-color:red"]'), 0, 600)
            }
        }
    }

    // This will fire only on personal application UDC not Personal Dealer.
    $applicationOptionsNext.on('click', function () {
        validateFinancialPositionAndNext('applicationOptions')
    })

    $financialPositionFinish.on('click', function() {
        personalLoan.app.submitLoan(true)
    })
    
    $applicationOptionsFinish.on('click', function() {
        validateFilesBeforeSubmit()
    })
    
    // This needs to be different to personal UDC as it still needs to validate and does not go to the application options step.
    $financialPositionFinishDealer.on('click', function() {
        validateFinancialPositionAndNext('applicationFinish')
    })

    // Validate files before submit if there is any
    function validateFilesBeforeSubmit () {
        if (!!personalLoan.applicationOptions.uploadFormFilesArr && personalLoan.applicationOptions.uploadFormFilesArr.length > 0) {
            if (personalLoan.applicationOptions.uploadFormFilesArr.every(onSubmitValidateFileSizeFormat)) {
                scrollToTop()
                personalLoan.app.submitLoan()
            } else {
                displayMessageModal()
            } 
        } else {
            personalLoan.app.submitLoan()
        }
    }

    function onSubmitValidateFileSizeFormat(file) {
        const validFormats = ['image/jpeg', 'image/png', 'application/pdf']
        const validSize = 20
        const validLength = 100
        if (
            bytesToMegaBytes(file.size) > validSize ||
            !validFileFormat(validFormats, file.type) ||
            file.name.split('.').pop().toLowerCase() === 'jpeg' ||
            file.name.length > validLength 
            ) {
            return false
        } else {
            return true
        }
    
        function bytesToMegaBytes(bytes) {
          return (bytes / (1024 * 1024)).toFixed(2)
        }
    
        function validFileFormat(formatArray, type) {
          return formatArray.includes(type)
        }
    }

    function displayMessageModal() {
        const maskWrapper = document.querySelector('.mask-wrapper')

        let originalHTML = ``

        if (!!maskWrapper) {
            originalHTML = maskWrapper.innerHTML
            maskWrapper.classList.remove('hidden')
            maskWrapper.innerHTML = `
                <div class="response-message">
                    <div class="message-row">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
                        </svg>
                        <div>
                            <h2>Upload Failed</h2>
                            <p>There was an error uploading your file. Please try again.</p>
                        </div>
                    </div>
                    <button class="response-message-button">Back to file upload</p>
                </div>
            `
        }

        const responseMessageButton = document.querySelector('.response-message-button')
        if (!!responseMessageButton) {
            responseMessageButton.addEventListener('click', function() {
                maskWrapper.classList.add('hidden')
                maskWrapper.innerHTML = originalHTML
            })
        }
    }

    jQuery('#purchaseItems').html('')

    $btnAddPurchaseItem.on('click', () => personalLoan.goodsType.addPurchaseItem())

    $navbarNav.on('click', function (event) {
        const $clickedMenu = jQuery(event.target)
        if ($clickedMenu.hasClass('nav-link')) {
            switch ($clickedMenu.data().routeName) {
                case 'about-you':
                    if (personalLoan.goodsType.validateYourDetails()) {
                        personalLoan.app.yourDetailsGoNext()
                    }
                    break

                case 'employment-details':
                    if (personalLoan.goodsType.validateAboutYou()) {
                        personalLoan.app.aboutYouGoNext()
                    }
                    break

                case 'financial-position':
                    if (personalLoan.goodsType.validateEmployeementDetails()) {
                        personalLoan.app.employmentDetailsGoNext()
                    }
                    break

                case 'your-details':
                    personalLoan.app.startLoanApplication()
                    break

                case 'application-options':
                    if (personalLoan.goodsType.validateAboutYou() && 
                        personalLoan.goodsType.validateEmployeementDetails() && 
                        personalLoan.goodsType.validateFinancialPosition()) {
                        personalLoan.app.applicationOptionsNext()
                    }
                    break

                default:
                    break
            }
        }
    })

    jQuery('.js-finish-application').on('click', function () {
        personalLoan.header.setActiveMenu('thank-you')
        personalLoan.router.go('thank-you')
    })

    var afKey = jQuery('#afKey').val();
    var personalAddress;
    var postalAddress;
    var previousAddress;
    var coborrowerPersonalAddress;
    var coborrowerPostalAddress;
    var coborrowerPreviousAddress;

    var initAddressFinder = function () {
        personalAddress = new AddressFinder.Widget(
            document.getElementById('address'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true}
        );
        postalAddress = new AddressFinder.Widget(
            document.getElementById('postAddress'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true }
        );
        previousAddress = new AddressFinder.Widget(
            document.getElementById('previousAddress'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true }
        );
        coborrowerPersonalAddress = new AddressFinder.Widget(
            document.getElementById('coborroweraddress'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true }
        );
        coborrowerPostalAddress = new AddressFinder.Widget(
            document.getElementById('coBorrowerPostAddress'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true}
        );
        coborrowerPreviousAddress = new AddressFinder.Widget(
            document.getElementById('coborrowerPreviousAddress'),
            afKey,
            'NZ', {
                "address_params": { "ascii": "1" },
            "location_params": { "ascii": "1" },
            "address_metadata_params": { "ascii": "1" },
            "show_locations": true }
        );
        personalAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('address').value = selected.fullAddress;
            $('#city').val(selected.city()); $('#city').trigger('change');
            //$('#country').val('New Zealand'); $('#country').trigger('change');
            $('#country').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#postcode').val(selected.postcode()); $('#postcode').trigger('change');
        });
        postalAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('postAddress').value = selected.fullAddress;
            $('#postcity').val(selected.city()); $('#postcity').trigger('change');
            //$('#postcountry').val('New Zealand'); $('#postcountry').trigger('change');
            $('#postcountry').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#postZipCode').val(selected.postcode()); $('#postZipCode').trigger('change');
        });
        previousAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('previousAddress').value = selected.fullAddress;
            $('#previousCity').val(selected.city()); $('#previousCity').trigger('change');
            //$('#previousCountry').val('New Zealand'); $('#previousCountry').trigger('change');
            $('#previousCountry').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#previousPostcode').val(selected.postcode()); $('#previousPostcode').trigger('change');
        });
        coborrowerPersonalAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('coborroweraddress').value = selected.fullAddress;
            $('#coborrowercity').val(selected.city()); $('#coborrowercity').trigger('change');
            //$('#coborrowercountry').val('New Zealand');
            $('#coborrowercountry').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#coborrowerpostcode').val(selected.postcode()); $('#coborrowerpostcode').trigger('change');
        });
        coborrowerPostalAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('coBorrowerPostAddress').value = selected.fullAddress;
            $('#coBorrowerPostCity').val(selected.city()); $('#coBorrowerPostCity').trigger('change');
            //$('#coBorrowerPostCountry').val('New Zealand'); $('#coBorrowerPostCountry').trigger('change');
            $('#coBorrowerPostCountry').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#coBorrowerPostZIP').val(selected.postcode()); $('#coBorrowerPostZIP').trigger('change');
        });
        coborrowerPreviousAddress.on('result:select', function (fullAddress, metaData) {
            var selected = new AddressFinder.NZSelectedAddress(fullAddress, metaData);
            document.getElementById('coborrowerPreviousAddress').value = selected.fullAddress;
            $('#coborrowerPreviousCity').val(selected.city()); $('#coborrowerPreviousCity').trigger('change');
            //$('#coborrowerPreviousCountry').val('New Zealand'); $('#coborrowerPreviousCountry').trigger('change');
            $('#coborrowerPreviousCountry').parent().find('.option').each(function () {
                if ($(this).text() == 'New Zealand') {
                    $(this).addClass('selected').trigger('click');
                }
            });
            $('#coborrowerPreviousPostcode').val(selected.postcode()); $('#coborrowerPreviousPostcode').trigger('change');
        });
    };

    function downloadAddressFinder() {
        var script = document.createElement('script');
        script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
        script.async = true;
        script.onload = initAddressFinder;
        document.body.appendChild(script);
    };

    window.addEventListener('load', downloadAddressFinder())

    $('.js-open-request-callback-popup').on('click', () => {
        // When user opens popup, take existing details from the form if he prefilled them already
        const firstName = $('#firstName').val()
        const lastName = $('#lastName').val()
        const mobileNumber = $('#mobileNumber').val()
        const email = $('#email').val()

        $('#requestCallbackFirstName').val(firstName)
        $('#requestCallbackLastName').val(lastName)
        $('#requestCallbackMobileNumber').val(mobileNumber)
        $('#requestCallbackEmail').val(email)

        $('.js-request-callback-popup').fadeIn()

        // add overflow hidden class to body
        $('body')[0].classList.add('overflow-hidden')
    })
    $('.js-close-request-callback-popup').on('click', () =>{
        $('.js-request-callback-popup').fadeOut()
        // remove overflow hidden from body
        $('body')[0].classList.remove('overflow-hidden')
        
    })

    $('.js-citizen-status').on('click', () => {
        $('.js-citizen-status').fadeOut()
        $('body')[0].classList.remove('overflow-hidden')
    })

    $('.js-close-request-callback-successful-popup').on('click', () => {
        // The Request callback is implemented only for UDC and AA Money and the requirment is to
        // redirect back to their main website once the callback success message is closed
        const isAAMoneyDealer = document.getElementById('isAAMoneyDealer').value === 'true'
        if (isAAMoneyDealer) {
            window.location.href = 'https://www.aamoney.co.nz/'
        } else {
            window.location.href = 'https://www.udc.co.nz/'
        }
    })

    /* ------------------------------------------------ */
    /* Updates 2025 to manage highly customized dealers */
    /* ------------------------------------------------ */
    
    // Read .js-switch-to-business-loan each element is an achnor element that already contains a path, we need to attach all existing query parameters to it
    $('.js-switch-to-business-loan').each(function() {
        const path = $(this).attr('href')
        const queryParams = window.location.search
        const url = `${path}${queryParams}`
        $(this).attr('href', url)
    })
})

// Exposed on window so other webpack modules (e.g. goods-type.js) can call it
// after dynamically adding household expense rows.
window.initTippy = function initTippy() {
    if (typeof window.tippy !== 'function') {
        return
    }

    var tooltipTargets = Array.prototype.filter.call(
        document.querySelectorAll('.js-tooltip'),
        function (el) { return !el._tippy }
    )
    var dropdownTargets = Array.prototype.filter.call(
        document.querySelectorAll('.js-tooltip-dropdown'),
        function (el) { return !el._tippy }
    )

    if (tooltipTargets.length) {
        window.tippy(tooltipTargets, {
            trigger: 'mouseenter click',
        })
    }
    if (dropdownTargets.length) {
        window.tippy(dropdownTargets)
    }
}

// Mobile menu
jQuery(function () {
    $(".cross").hide();
    $(".menu").hide();
    $(".hamburger").on("click", function () {
        $(".menu").slideToggle("slow", function () {
            $(".hamburger").hide();
            $(".cross").show();
        });
    });

    $(".cross").on("click", function () {
        $(".menu").slideToggle("slow", function () {
            $(".cross").hide();
            $(".hamburger").show();
        });
    });
})

// format money
window.formatMoney = function(num) {
    var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
    if (str.indexOf(".") > 0) {
        parts = str.split(".");
        str = parts[0];
    }
    str = str.split("").reverse();
    for (var j = 0, len = str.length; j < len; j++) {
        if (str[j] != ",") {
            output.push(str[j]);
            // if (i % 3 == 0 && j < (len - 1)) {
            //     output.push(",");
            // }
            i++;
        }
    }
    formatted = output.reverse().join("");
    return (formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
};

// format money input. e.g 10000 -> 10,000
function formatMoneyControl(elem) {
    elem.on('keyup', function (e) {
        if(e.target.classList.contains('js-allow-zero')) {
            if (this.value.charAt(0) === '.') {
                $(this).val('')
            }
        } else {
            if (this.value.charAt(0) === '.' || this.value.charAt(0) === '0') {
                $(this).val('')
            }
        } 
        this.value = this.value.replace(/[^0-9\.\|\,]/g, '')
        // Enforce max 7 digits before decimal and 2 after, but keep trailing dot if user just typed it
        var val = this.value
        var parts = val.split('.')
        var intPart = parts[0].slice(0, 7)
        var decPart = parts[1] !== undefined ? parts[1].slice(0, 2) : undefined
        // If user just typed a dot, keep it
        if (val.endsWith('.') && decPart === undefined) {
            this.value = intPart + '.'
        } else if (decPart !== undefined) {
            this.value = intPart + '.' + decPart
        } else {
            this.value = intPart
        }
        $(this).val(window.formatMoney($(this).val()))
    })
}

$(function () {
    function generateRandomString () {
        return Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7)
    }

    const moneyControl = $('.js-money-control')
    const randomString = generateRandomString()

    formatMoneyControl(moneyControl)

    $('.card-head .card-icon').attr('src', '/resources/images/icons/car-monotone-white.png')

    // Disabled all input, that don't already have an autocomplete attribute, so we retain the ones we want to keep
    $('input:not([autocomplete])').attr('autocomplete', randomString)

    // Read a hidden input #disableAutoComplete to see if inputs inside #your-details-form-individual should have autocomplete disabled
    // Use a random string to disable autocomplete as the best way of doing it https://stackoverflow.com/a/34998771/23328884
    const isAAMoneyDealer = document.getElementById('isAAMoneyDealer').value === 'true'
    if (($('#hdnDealerId').val() !== '' || $('#hdnDealerUid').val() !== '') && !isAAMoneyDealer) {
        console.log('Disabling Your Details section autocomplete')
        $('#your-details-form-individual input').attr('autocomplete', randomString)

        // Set name atrribute to random string, these seems the only way to disabled browser auto suggestion
        $('#firstName').attr('name', generateRandomString())
        $('#middleName').attr('name', generateRandomString())
        $('#lastName').attr('name', generateRandomString())
        $('#mobileNumber').attr('name', generateRandomString())
        $('#email').attr('name', generateRandomString())
    } 
    
    $('#your-details-form-individual').on('submit', (event) => event.preventDefault())
})

// Append new citizenship field
$('.form-wrapper .js-add-new-citizenship').on('click', addCitizenship);
$('.form-wrapper .js-citizenship-wrapper').on('click', '.remove-item', removeCitizenship);

function addCitizenship() {
    var html = $(this).closest('.form-wrapper').find('.js-citizenship-template').html();
    $(this).closest('.form-wrapper').find('.js-citizenship-template')
    $(this).closest('.form-wrapper').find('.js-citizenship-wrapper').append(html);
}

function removeCitizenship() {
    $(this).parent().parent().remove();
}

// Added for aa personal loan new form
$('.js-add-aa-personal-vehicle').on('click', addAAVehicle)
$('.js-aa-personal-vehicles-container').on('click', '.remove-item', removeAAVehicle)

function addAAVehicle() {
    var html = $('.js-add-aa-personal-vehicle-template').html()
    $('.js-aa-personal-vehicles-container').prepend(html)
}

function removeAAVehicle() {
    $(this).closest('.js-aa-personal-vehicle-wrapper').remove()
}

// checkbox event
$('.postalCheckbox').on("click", function () {
    $(this).parent().find('input').trigger('click');
    if ($(this).parent().find('input').prop('checked')) {
        $(this).addClass('checked');
    } else {
        $(this).removeClass('checked');
    }

    if ($(this).next().prop('checked')) {
        $(this).addClass('checked');
    } else {
        $(this).removeClass('checked');
    }
});

// use keyboard on dropdown menu
$(window).on('keyup', function (e) {
    var code = (e.keyCode ? e.keyCode : e.which);
    if (code == 9 && $('#loanTerm:focus').length) {

    }
});

// replace img for honda red theme 
function addHondaImage() {
    if ($('.honda-theme').length > 0) {
        $("img[src='/resources/images/logo.png']").eq(0).attr('src', '/resources/images/icons/088525-logo.png')
    }
}

window.getParameterByName = function(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// on next button click, scroll to first error in view when there is any
function onClickScrollToError(elem, elemIndex, time) {
    const elementOffset = elem.eq(elemIndex).offset().top
    $('html, body').animate({
        scrollTop: elementOffset - $(window).height()/2
    }, time);

    // Let the parent window know to scroll to the first error
    window.parent.postMessage({
        name: 'UDCscrollToPosition',
        value: elementOffset > 0 ? elementOffset - 50 : elementOffset // Small offset to make sure the input label is visible
    }, '*')
}

addHondaImage();
window.initTippy();

// Set address finder list width as address input box
function adjustGooglePlaceAutocompleteResultsWidth() {
    $('ul.af_list').css('max-width', `${$('#address').width() + 20}px`)
}

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}

function transformFormModelToLegacyFormat(newFormModel) {
    if (!newFormModel) return null

    // Helper function to safely get string values
    const safeString = (value) => value || ""
    
    // Helper function to safely get number values
    const safeNumber = (value) => {
        if (value === null || value === undefined || value === "") return null
        return typeof value === 'string' ? parseInt(value, 10) : value
    }

    // Helper function to convert boolean to Yes/No string
    const booleanToYesNo = (value) => {
        return value ? "Yes" : "No"
    }

    // Helper function to convert country code to name
    const getCountryName = (countryCode) => {
        if (!countryCode) return ''
        
        // Handle comma-separated list of country codes
        if (countryCode.includes(',')) {
            return countryCode.split(',')
                .map(code => {
                    const country = listOfCountries.find(c => c.value === code.trim())
                    return country ? country.name : code.trim()
                })
                .join(',')
        }
        
        // Handle single country code
        const country = listOfCountries.find(c => c.value === countryCode)
        return country ? country.name : countryCode
    }

    // Transform purchase items (convert single object to array)
    const transformPurchaseItems = (purchaseItems) => {
        if (!purchaseItems) {
            return [{
                ItemType: "",
                Year: "",
                New: false,
                Used: false,
                PurchasePrice: "",
                CashDeposit: "",
                Make: "",
                Model: "",
                LoanTerm: "",
                RepaymentFrequency: ""
            }]
        }
        
        return [{
            ItemType: safeString(purchaseItems.itemType),
            Year: safeString(purchaseItems.year),
            New: false, // Default values as these don't exist in new format
            Used: false,
            PurchasePrice: safeString(purchaseItems.purchasePrice),
            CashDeposit: safeString(purchaseItems.cashDeposit),
            Make: safeString(purchaseItems.make),
            Model: safeString(purchaseItems.model),
            LoanTerm: safeString(purchaseItems.loanTerm),
            RepaymentFrequency: safeString(purchaseItems.repaymentFrequency)
        }]
    }

    // Transform other incomes
    const transformOtherIncomes = (otherIncomes) => {
        if (!otherIncomes || !Array.isArray(otherIncomes)) return []
        
        return otherIncomes.map(income => ({
            Amount: safeNumber(income.amount),
            Frequency: safeString(income.frequency),
            IncomeType: safeString(income.incomeType),
            IsBorrower: Boolean(income.isBorrower)
        }))
    }

    // Transform other assets
    const transformOtherAssets = (otherAssets) => {
        if (!otherAssets || !Array.isArray(otherAssets)) return []
        
        return otherAssets.map(asset => ({
            AssetType: safeString(asset.assetType),
            Amount: safeNumber(asset.amount)
        }))
    }

    // Transform other financial commitments
    const transformOtherFinancialCommitments = (commitments) => {
        if (!commitments || !Array.isArray(commitments)) return []
        
        return commitments.map(commitment => ({
            Description: safeString(commitment.description),
            Amount: safeNumber(commitment.amount),
            MonthlyPayments: safeNumber(commitment.monthlyPayments)
        }))
    }

    // Transform other recurring expenses
    const transformOtherRecurringExpenses = (expenses) => {
        if (!expenses || !Array.isArray(expenses)) return []
        
        return expenses.map(expense => ({
            ExpenseType: safeString(expense.expenseType),
            Amount: safeNumber(expense.amount || expense.monthlyPayments),
            Frequency: "Monthly" // Default frequency as this is not in new format
        }))
    }

    const personal = newFormModel.personal || {}
    const yourDetails = personal.yourDetails || {}
    const aboutYou = personal.aboutYou || {}
    const income = personal.income || {}
    const financialPosition = personal.financialPosition || {}
    const applicationOptions = personal.applicationOptions || {}
    const coBorrowerDetails = aboutYou.coBorrowerDetails || {}
    
    let AAPersonal = null
    if (newFormModel.aaPersonal !== null && newFormModel.aaPersonal !== undefined) {
        AAPersonal = {
            PersonalLoanType: newFormModel.aaPersonal.personalLoanType || '',
            PersonalLoanReason: newFormModel.aaPersonal.personalLoanReason || '',
            LoanForVehicle: newFormModel.aaPersonal.loanForVehicle || false,
            DebtConsolidationReason: Array.isArray(newFormModel.aaPersonal.debtConsolidationReason) ? newFormModel.aaPersonal.debtConsolidationReason : [],
            Vehicles: Array.isArray(newFormModel.aaPersonal.vehicles) ? newFormModel.aaPersonal.vehicles.map(vehicle => ({
                Registration: vehicle.registration || '',
                Make: vehicle.make || '',
                Model: vehicle.model || '',
                ModelYear: vehicle.modelYear || '',
                Kilometres: vehicle.kilometres || ''
            })) : []
        }
    }

    const legacyFormat = {
        Id: safeString(newFormModel.formId),
        IsPostCall: Boolean(newFormModel.isPostCall),
        AAPersonal: AAPersonal,
        PreferredLoan: safeString(aboutYou.purchaseItems?.loanTerm),
        LoanTerm: "",
        PaymentFrequency: safeString(aboutYou.purchaseItems?.repaymentFrequency),
        Title: safeString(yourDetails.title),
        TeslaReferenceNumber: safeString(newFormModel.teslaReferenceNumber),
        AaMoneyMembershipNumber: safeString(newFormModel.aaMembershipNumber),
        FirstName: safeString(yourDetails.firstName),
        MiddleName: safeString(yourDetails.middleName),
        LastName: safeString(yourDetails.lastName),
        Phone: safeString(yourDetails.mobileNumber),
        Email: safeString(yourDetails.email),
        DOB: safeString(yourDetails.dateOfBirth),
        MaritalStatus: safeString(aboutYou.maritalStatus),
        DependantsNumber: safeNumber(aboutYou.dependantsNumber),
        DependantsAge: "0", // Default value as this doesn't exist in new format
        Address: safeString(aboutYou.address),
        City: safeString(aboutYou.city),
        ZIP: safeString(aboutYou.ZIP),
        Country: getCountryName(aboutYou.country),
        ResidenceType: safeString(aboutYou.residenceType),
        PostAddress: safeString(aboutYou.postAddress),
        PostCity: safeString(aboutYou.postCity),
        PostZIP: safeString(aboutYou.postZIP),
        PostCountry: getCountryName(aboutYou.postCountry),
        TimeAtAddressYears: safeNumber(aboutYou.timeAtAddressYears),
        TimeAtAddressMonths: safeNumber(aboutYou.timeAtAddressMonths),
        PreviousAddress: safeString(aboutYou.previousAddress),
        PreviousCity: safeString(aboutYou.previousCity),
        PreviousZIP: safeString(aboutYou.previousZIP),
        PreviousCountry: getCountryName(aboutYou.previousCountry),
        PreviousTimeAtAddressYears: safeNumber(aboutYou.previousTimeAtAddressYears),
        PreviousTimeAtAddressMonths: safeNumber(aboutYou.previousTimeAtAddressMonths),
        NZResident: Boolean(aboutYou.nzResident),
        CountryOfBirth: getCountryName(aboutYou.countryOfBirth),
        CountryOfCitizenship: getCountryName(aboutYou.countryOfCitizenship),
        CountryOfAnotherCitizen: "", // Legacy field not in new format
        DriverLicenceType: safeString(aboutYou.driverLicenceType),
        DriverLicenceNumber: safeString(aboutYou.driverLicenceNumber),
        DriverLicenceVersion: safeString(aboutYou.driverLicenceVersion),
        ReuseForPostalAddress: Boolean(aboutYou.reuseForPostalAddress),
        IsCompleted: false, // Legacy field not in new format
        IsPersonal: true, // Legacy field not in new format
        DealerId: safeString(newFormModel.dealerId),
        IsJoint: Boolean(aboutYou.isJoint),
        OtherIncome: booleanToYesNo(income.otherIncome),
        Asset: {
            OwnHome: Boolean(financialPosition.isOwnHome),
            RentHome: !Boolean(financialPosition.isOwnHome), // Inverse of OwnHome
            MortgateValue: safeNumber(financialPosition.mortgateValue),
            MortgateBalance: safeNumber(financialPosition.mortgateBalance),
            MortgateMonthlyPayment: safeNumber(financialPosition.mortgateMonthlyPayment),
            VehicleValue: safeNumber(financialPosition.vehicleValue),
            VehicleAmount: 0, // Default value as this doesn't exist in new format
            VehicleMonthlyPayment: 0, // Default value as this doesn't exist in new format
            FurnitureValue: safeNumber(financialPosition.furnitureValue),
            FurnitureAmount: 0, // Default value as this doesn't exist in new format
            FurnitureMonthlyPayment: 0, // Default value as this doesn't exist in new format
            PersonalLoanValue: 0, // Default value as this doesn't exist in new format
            PersonalLoanAmount: safeNumber(financialPosition.personalLoanAmount),
            PersonalLoanMonthlyPayment: safeNumber(financialPosition.personalLoanMonthlyPayment),
            CreditCardValue: 0, // Default value as this doesn't exist in new format
            CreditCardAmount: safeNumber(financialPosition.creditCardAmount),
            CreditCardMonthlyPayment: safeNumber(financialPosition.creditCardMonthlyPayment),
            OtherValue: 0, // Default value as this doesn't exist in new format
            OtherAmount: safeNumber(financialPosition.otherAmount),
            OtherMonthlyPayment: safeNumber(financialPosition.otherMonthlyPayment),
            AdditionalNotes: safeString(financialPosition.additionalNotes),
            MortgageRentPaymentAmount: safeNumber(financialPosition.mortgageRentPaymentAmount),
            CouncilRatesExpenditureValueFrequency: "Monthly", // Default frequency
            CouncilRatesExpenditureValue: safeNumber(financialPosition.councilRatesExpenditureValue),
            HomeInsuranceExpenditureValueFrequency: "Monthly", // Default frequency
            HomeInsuranceExpenditureValue: safeNumber(financialPosition.homeInsuranceExpenditureValue),
            UtilitiesExpenditureValueFrequency: "Monthly", // Default frequency
            UtilitiesExpenditureValue: safeNumber(financialPosition.utilitiesExpenditureValue),
            LivingExpenditureValueFrequency: "Monthly", // Default frequency
            LivingExpenditureValue: safeNumber(financialPosition.livingExpenditureValue),
            VehicleExpenditureValueFrequency: "Monthly", // Default frequency
            VehicleExpenditureValue: safeNumber(financialPosition.vehicleExpenditureValue),
            OtherRecurringExpenses: transformOtherRecurringExpenses(financialPosition.otherRecurringExpenses)
        },
        Personal: {
            CompanyName: safeString(income.companyName),
            Occupation: safeString(income.occupation),
            EmploymentType: safeString(income.employmentType),
            EmployerPhoneNumber: "", // Legacy field not in new format
            EmployerAddress: "", // Legacy field not in new format
            EmployerCity: "", // Legacy field not in new format
            EmployerZIP: "", // Legacy field not in new format
            EmployerCountry: "", // Legacy field not in new format
            TimeInThisJobYears: safeNumber(income.timeInThisJobYears),
            TimeInThisJobMonths: 0, // Default value as this doesn't exist in new format
            PreviousCompanyName: safeString(income.previousCompanyName),
            PreviousOccupation: safeString(income.previousOccupation),
            PreviousEmploymentType: safeString(income.previousEmploymentType),
            PreviousTimeInThisJobYears: safeNumber(income.previousTimeInThisJobYears),
            PreviousEmployer: "", // Legacy field not in new format
            CoBorrowerTitle: safeString(coBorrowerDetails.coBorrowerTitle),
            CoBorrowerFirstName: safeString(coBorrowerDetails.coBorrowerFirstName),
            CoBorrowerMiddleName: safeString(coBorrowerDetails.coBorrowerMiddleName),
            CoBorrowerLastName: safeString(coBorrowerDetails.coBorrowerLastName),
            CoBorrowerPhoneNumber: safeString(coBorrowerDetails.coBorrowerPhoneNumber),
            CoBorrowerEmail: safeString(coBorrowerDetails.coBorrowerEmail),
            CoBorrowerDOB: safeString(coBorrowerDetails.coBorrowerDOB),
            CoBorrowerMaritalStatus: safeString(coBorrowerDetails.coBorrowerMaritalStatus),
            CoBorrowerDependantsNumber: safeNumber(coBorrowerDetails.coBorrowerDependantsNumber),
            CoBorrowerDependantsAge: "0", // Default value as this doesn't exist in new format
            CoBorrowerAddress: safeString(coBorrowerDetails.coBorrowerAddress),
            CoBorrowerCity: safeString(coBorrowerDetails.coBorrowerCity),
            CoBorrowerZIP: safeString(coBorrowerDetails.coBorrowerZIP),
            CoBorrowerCountry: getCountryName(coBorrowerDetails.coBorrowerCountry),
            CoBorrowerResidenceType: safeString(coBorrowerDetails.coBorrowerResidenceType),
            CoBorrowerReuseForPostalAddress: Boolean(coBorrowerDetails.coBorrowerReuseForPostalAddress),
            CoBorrowerPostAddress: safeString(coBorrowerDetails.coBorrowerPostAddress),
            CoBorrowerPostCity: safeString(coBorrowerDetails.coBorrowerPostCity),
            CoBorrowerPostZIP: safeString(coBorrowerDetails.coBorrowerPostZIP),
            CoBorrowerPostCountry: getCountryName(coBorrowerDetails.coBorrowerPostCountry),
            CoBorrowerTimeAtAddressYears: safeNumber(coBorrowerDetails.coBorrowerTimeAtAddressYears),
            CoBorrowerTimeAtAddressMonths: safeNumber(coBorrowerDetails.coBorrowerTimeAtAddressMonths),
            CoBorrowerPreviousAddress: safeString(coBorrowerDetails.coBorrowerPreviousAddress),
            CoBorrowerPreviousCity: safeString(coBorrowerDetails.coBorrowerPreviousCity),
            CoBorrowerPreviousZIP: safeString(coBorrowerDetails.coBorrowerPreviousZIP),
            CoBorrowerPreviousCountry: getCountryName(coBorrowerDetails.coBorrowerPreviousCountry),
            CoBorrowerPreviousTimeAtAddressYears: safeNumber(coBorrowerDetails.coBorrowerPreviousTimeAtAddressYears),
            CoBorrowerPreviousTimeAtAddressMonths: safeNumber(coBorrowerDetails.coBorrowerPreviousTimeAtAddressMonths),
            CoBorrowerNZResident: Boolean(coBorrowerDetails.coBorrowerNZResident),
            CoBorrowerCountryOfBirth: getCountryName(coBorrowerDetails.coBorrowerCountryOfBirth),
            CoBorrowerCountryOfCitizenship: getCountryName(coBorrowerDetails.coBorrowerCountryOfCitizenship),
            CoBorrowerCountryOfAnotherCitizen: false, // Legacy field not in new format
            CoBorrowerDriverLicenceType: safeString(coBorrowerDetails.coBorrowerDriverLicenceType),
            CoBorrowerDriverLicenceNumber: safeString(coBorrowerDetails.coBorrowerDriverLicenceNumber),
            CoBorrowerDriverLicenceVersion: safeString(coBorrowerDetails.coBorrowerDriverLicenceVersion),
            CoBorrowerCompanyName: safeString(income.coBorrowerCompanyName),
            CoBorrowerOccupation: safeString(income.coBorrowerOccupation),
            CoBorrowerEmploymentType: safeString(income.coBorrowerEmploymentType),
            CoBorrowerTimeInThisJobYears: safeNumber(income.coBorrowerTimeInThisJobYears),
            CoBorrowerPreviousCompanyName: safeString(income.coBorrowerPreviousCompanyName),
            CoBorrowerPreviousOccupation: safeString(income.coBorrowerPreviousOccupation),
            CoBorrowerPreviousEmploymentType: safeString(income.coBorrowerPreviousEmploymentType),
            CoBorrowerPreviousTimeInThisJobYears: safeNumber(income.coBorrowerPreviousTimeInThisJobYears),
            CoBorrowerOtherIncome: booleanToYesNo(income.coBorrowerOtherIncome),
            Income: safeNumber(income.incomeAmount),
            TakeHomePayFrequency: safeString(income.takeHomePayFrequency),
            SpousePartnerIncome: safeNumber(income.spousePartnerIncome),
            SpousePartnerFrequency: safeString(income.spousePartnerFrequency),
            IncomeDecreaseExpected: Boolean(income.incomeDecreaseExpected),
            IncomeDecreaseDetails: safeString(income.incomeDecreaseDetails),
            NameOfRelative: "", // Legacy field not in new format
            RelativeRelationshipToCustomer: "", // Legacy field not in new format
            RelativePhoneNumber: "", // Legacy field not in new format
            RelativeAddressLine1: "", // Legacy field not in new format
            RelativeAddressLine2: "", // Legacy field not in new format
            RelativeAddressLine3: "", // Legacy field not in new format
            CoBorrowerIsCheckedAplyID: Boolean(applicationOptions.coBorrowerIsCheckedAplyID),
            CoBorrowerIsCheckedThisIsBud: false, // Legacy field not in new format
            NoPreviousEmployer: Boolean(income.noPreviousEmployer), // Legacy field not in new format
            NoCoBorrowerPreviousEmployer: Boolean(income.noCoBorrowerPreviousEmployer) // Legacy field not in new format
        },
        PurchaseItems: transformPurchaseItems(aboutYou.purchaseItems),
        OtherIncomes: transformOtherIncomes(income.otherIncomes),
        OtherAssets: transformOtherAssets(financialPosition.otherAssets),
        OtherFinancialCommitments: transformOtherFinancialCommitments(financialPosition.otherFinancialCommitments),
        IsCheckedAplyID: Boolean(applicationOptions.isCheckedAplyID),
        IsCheckedThisIsBud: false // Legacy field not in new format
    }

    return legacyFormat
}
